import { create } from 'zustand'

interface PhoneNumberCountState {
   count: number
   setCount: (count: number) => void
}

export const useCampaignPhoneNumberCountStore = create<PhoneNumberCountState>()(
   (set) => ({
      count: 0,
      setCount: (count) => set({ count }),
   })
)
